declare global {
  var env: EnvModel;
}


export interface EnvModel {
    bookingSitePath: string;
    shoppingCartApiPath: string;
    mainSitePath: string;
    eventSitePath: string;
    checkoutSitePath: string;
    googlePayEnvironment: string;
}

export const getEnvModel = (): EnvModel => {
  return window.env;
}